import { createEntityCollectionStore } from '@core/ngrx-legacy';
import type { JobBasic } from '@core/offers-types';

import { EntityStoreKey } from '../../types';

const {
  namespace,
  actions: defaultActions,
  reducer,
  selectors: { byId },
} = createEntityCollectionStore<{
  offers: JobBasic[];
  id: string;
}>()(EntityStoreKey.OffersByCompany);

const actions = {
  fetchOne: defaultActions.fetchOne,
  fetchOneSuccess: defaultActions.fetchOneSuccess,
  fetchOneFailed: defaultActions.fetchOneFailed,
};

const OffersByCompanySelectors = { byId };

export {
  actions as OffersByCompanyActions,
  reducer as OffersByCompanyReducer,
  OffersByCompanySelectors,
  namespace as OffersByCompanyNamespace,
};
